import React from 'react';
import ProfileList from './ProfileList';

// This component serves as a wrapper for the existing ProfileList
// In the future, it could be enhanced with additional filtering/sorting options
export default function BrowseProfiles() {
  return (
    <div className="browse-profiles-container">
      <h1>Browse Profiles</h1>
      <div className="browse-profiles-content">
        {/* Later we can add filters, search, etc. here */}
        <ProfileList hideTitle={true} />
      </div>
    </div>
  );
}
